import { React, useRef, useState } from "react"

import Form from "./Form"
import DialogComponent from "Components/UI/Molecules/Modals/DialogComponent"
import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import { interfaces } from "service/interfaces"

import CancelConfirmButtons from "Components/UI/Molecules/CancelConfirmButtons"

const Edit = (props) => {
  const { changeRender, idAddress, open, handleclose, data } = props
  const formSubmitRef = useRef(null)
  const createDismissableSnackbar = useCustomSnackbar()

  const handleSubmit = () => {
    formSubmitRef.current.click()
  }
  const [loading, setLoading] = useState(false)
  
  const onSubmit = async (values) => {
    setLoading(true)
    const value = {
        calle: values.calle.toUpperCase(),
    }
    await interfaces.configInterface
      .updateAddres(idAddress, value)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: "success",
        })
        changeRender()
      })
      .catch((error) =>
        createDismissableSnackbar(error.response.data.data, {
          variant: "error",
        })
      )
      .finally(handleclose)
    setLoading(false)
  }

  return (
    <DialogComponent
      open={open}
      handleclose={handleclose}
      widthLarge="500px"
      title="Editar dirección"
      children={
        <Form
          ref={formSubmitRef}
          onSubmit={onSubmit}
          data={data}
        />
      }
      disableChildHeight
      disableBackdropClick
      disableEscapeKeyDown
      actions={
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <CancelConfirmButtons
            onClickCancel={handleclose}
            onClickSubmit={handleSubmit}
            disabledCancel={loading}
            disabledSubmit={loading}
            isLoading={loading}
          />
        </div>
      }
    />
  )
}

export default Edit
